import { useQuery } from '@tanstack/react-query';
import { USE_GOBODO_API } from '../../utils/gobodoUtils';
import { fetchGobodoApplications } from '../gobodo/gobodoApplicationService';

export interface ApplicationOption {
  value: string;
  label: string;
}

const FALLBACK_OPTIONS: ApplicationOption[] = [
  { value: 'all', label: 'All Applications' },
  { value: 'global', label: 'Global/Shared' },
  { value: 'cybersweep', label: 'CyberSweep' },
  { value: 'credit-repair', label: 'Credit Repair' },
  { value: 'credit-development', label: 'Credit Development' },
  { value: 'credit-block', label: 'Credit Block' },
  { value: 'id-theft', label: 'ID Theft Recovery' },
  { value: 'regal-main', label: 'Regal Main' },
];

export const applicationKeys = {
  all: ['applications'] as const,
};

export function useApplications() {
  return useQuery({
    queryKey: applicationKeys.all,
    queryFn: async (): Promise<ApplicationOption[]> => {
      if (!USE_GOBODO_API) return FALLBACK_OPTIONS;
      try {
        const list = await fetchGobodoApplications();
        return list.length > 0 ? list : FALLBACK_OPTIONS;
      } catch {
        return FALLBACK_OPTIONS;
      }
    },
    staleTime: 10 * 60 * 1000,
  });
}
